import { useCallback, useSyncExternalStore } from 'react';

// Границы совпадают с брейкпоинтами Tailwind: то, что решается в JS (число месяцев в календаре,
// ширина оси графика), обязано переключаться ровно там же, где классы `max-sm:` и `lg:`.
// Иначе на 640px вёрстка была бы уже «мобильной», а график — ещё десктопным.
export const MOBILE_MEDIA_QUERY = '(max-width: 639.98px)';
export const DESKTOP_MEDIA_QUERY = '(min-width: 1024px)';

const getMediaQueryList = (query) =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(query)
    : null;

export const useMediaQuery = (query) => {
  const subscribe = useCallback(
    (onChange) => {
      const mediaQueryList = getMediaQueryList(query);
      if (!mediaQueryList) {
        return () => {};
      }

      mediaQueryList.addEventListener('change', onChange);
      return () => mediaQueryList.removeEventListener('change', onChange);
    },
    [query]
  );

  const getSnapshot = () => getMediaQueryList(query)?.matches ?? false;

  return useSyncExternalStore(subscribe, getSnapshot, () => false);
};

/** Телефон: ниже `sm` (640px), то есть там же, где действуют классы `max-sm:`. */
export const useIsMobile = () => useMediaQuery(MOBILE_MEDIA_QUERY);

/** Десктоп: от `lg` (1024px) — сайдбар на месте, ниже него меню выезжает по кнопке. */
export const useIsDesktop = () => useMediaQuery(DESKTOP_MEDIA_QUERY);
